import sensors from "@/utils/sensors/sensors_config";
import { isApp } from "@/utils/bridge/index.js";
//页面

export default {
  //序号1-PageView-页面浏览
  $pv(page_name: any, forward_page_name: any) {
    sensors.track("PageView", {
      page_name, // 页面名称
      forward_page_name, //前向页面名称
    });
  },
  //   授信号 作为唯一标识
  $uv(page_name: any, credit_no: any) {
    sensors.track("UserView", {
      page_name, // 页面名称
      credit_no, // 授信单号
    });
  },
  //序号2-PageLeave-页面离开
  $pl(page_name: any, forward_page_name: any, view_time: any) {
    sensors.track("PageLeave", {
      page_name, // 页面名称
      forward_page_name, //前向页面名称
      view_time, // 浏览时长
    });
  },
  //序号3-PageButtonClick-页面功能按钮点击
  $pc(page_name: any, button_name: any) {
    sensors.track("PageButtonClick", {
      page_name, // 页面名称
      button_name, //按钮名称
    });
  },
  //序号4-CardView-页面卡片曝光
  $cv(page_name: any, card_name: any) {
    sensors.track("CardView", {
      page_name, // 页面名称
      card_name, //卡片名称
    });
  },
  //序号5-CardClick-页面卡片点击
  $cc(page_name: any, card_name: any, card_status: any) {
    sensors.track("CardClick", {
      page_name, // 页面名称
      card_name, //卡片名称
      card_status, // 卡片状态
    });
  },
  //序号6-TabClick-页面功能按钮点击
  $tc(page_name: any, button_name: any) {
    sensors.track("TabClick", {
      page_name, // 页面名称
      button_name, //按钮名称
    });
  },
  //下载渠道上传
  $rp(deviceCode: any) {
    if (deviceCode == undefined || deviceCode == "null" || deviceCode == "" || deviceCode == null) {
      return;
    }
    console.log("$rp", deviceCode);
    sensors.registerPage({
      // 这里配置需要修改
      platform_type: isApp() ? "Android" : "H5",
      is_login: null,
      experiment_group: null,
      experiment_id: null,
      experiment_name: null,
      business_line: null,
      channel_number: deviceCode, // 渠道号
    });
  },
  //获取神策匿名ID
  $getAnonymousID() {
    return sensors.quick("getAnonymousID");
  },
  //登录时绑定业务ID
  $login(id: any) {
    sensors.login(`${id}`);
  },
  $setProfile(params: any) {
    sensors.setProfile({ ...params });
  },
};
